import React from "react";
import CustomSection from "../components/CustomSection";
import BackButton from "../components/BackButton";

const AboutUs = () => {
  return (
    <CustomSection type="white">
      <BackButton />
      <div className="m-6 has-text-justified">
        <h1>Sobre TREFF</h1>
        <br />
        <p>
          En el corazón de nuestra identidad, "TREFF" se inspira en la palabra
          alemana que significa "encuentro" o "reunión". Somos más que una
          plataforma; somos un punto de encuentro virtual creado por
          profesionales y freelancers para freelancers. En TREFF, creemos en
          canalizar el talento de las personas y conectarlas con clientes
          exigentes, estableciendo un espacio donde las habilidades se
          encuentran con las necesidades.
        </p>

        <p>
          TREFF es una empresa mexicana con sede en Guadalajara, Jalisco,
          fundada por profesionales y freelancers, con un enfoque específico en
          atender las necesidades de otros freelancers.
        </p>

        <p>
          Contamos con una sólida experiencia en áreas como administración,
          contabilidad, finanzas, asesoría fiscal, desarrollo y gestión de
          proyectos, innovación, metodologías ágiles y mejora continua, entre
          otros. Nuestra misión principal es canalizar el talento de las
          personas para satisfacer las demandas de los clientes más exigentes.
        </p>

        <p>
          Actuamos como intermediarios entre freelancers y el mercado, siempre
          asegurándonos de que se entreguen trabajos de alta calidad a clientes
          comprometidos, protegiendo en todo momento los intereses de ambas
          partes.
        </p>

        <p>Para ti, cliente:</p>

        <p>
          En TREFF, te ofrecemos una plataforma donde encontrarás una amplia
          variedad de servicios proporcionados por freelancers comprometidos a
          resolver tus necesidades. Evitarás la contratación de grandes empresas
          y disfrutarás de beneficios como precios competitivos y un trato
          personalizado. En TREFF, actuamos como mediadores entre tus
          necesidades y la entrega de un trabajo de calidad.
        </p>

        <p>
          Nuestro catálogo de servicios abarca una amplia gama, ofrecidos por
          expertos en sus respectivos campos. Puedes encontrar a alguien que
          realice actividades fuera de tu área de experiencia de manera remota,
          aprovechando tecnologías digitales para resolverlo.
        </p>

        <p>
          Nos comprometemos a cuidar de tu inversión y garantizar la calidad del
          servicio desde la contratación hasta la entrega del trabajo, siempre
          velando por la seguridad de ambas partes. Además, garantizamos que
          todos los freelancers en la comunidad TREFF han pasado por un riguroso
          proceso de validación y confirmación de perfil para garantizar tu
          seguridad en la contratación, tu inversión y la calidad del servicio
          que recibirás.
        </p>

        <p>Para ti, freelancer:</p>

        <p>
          Ofrecemos una herramienta confiable diseñada para que ofrezcas tus
          servicios como experto independiente de manera amigable, ágil y
          segura.
        </p>

        <p>
          Siempre contarás con el respaldo de TREFF, asegurando tus pagos por
          los trabajos realizados de acuerdo con tus tiempos, capacidades y
          tarifas. Dejamos en tus manos la posibilidad de aumentar y exponer tu
          talento según tus preferencias.
        </p>

        <p>
          En TREFF, estamos comprometidos a ser el punto de encuentro que
          posiciona y promociona tus servicios en un mercado que abarca clientes
          potenciales en México y Latinoamérica. Creemos en la calidad, la
          seguridad y la validación, garantizando que todos los freelancers en
          nuestra comunidad hayan pasado por un riguroso proceso de confirmación
          de perfil.
        </p>

        <p>
          Bienvenido a TREFF, donde el talento se encuentra con las
          oportunidades, y cada encuentro es una puerta abierta hacia el éxito.
        </p>
      </div>
    </CustomSection>
  );
};

export default AboutUs;
